<template>
  <div class="c-material-compare">
    <m-compare-table
      :is-show-table="showTable"
      :no-data="noData"
      :loading="loading"
      :compares="compares"
      :data="tableList"
      :media-data="mediaData"
      @on-add="addCompares"
      @on-delete="delCompares"
      @on-convert="convertCompares"
      @on-export="downData"
    />

    <Modal
      v-model="modal"
      :mask-closable="false"
      :loading="!asyning"
      title="选择素材进行对比"
      width="720"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
      @on-ok="asyncSelect"
    >
      <Form :label-width="140">
        <FormItem label="统计时间">
          <DateRangePicker v-model="datetime" :clearable="false" @change="handleDatetime" style="width: 220px"></DateRangePicker>
        </FormItem>
        <FormItem label="平台类型">
          <Select :value="modePlatform" style="width: 280px" placeholder="请选择平台类型" @on-change="handlePlatform">
            <Option :value="0" :key="0">全部</Option>
            <Option :value="1" :key="1">安卓</Option>
            <Option :value="2" :key="2">iOS</Option>
          </Select>
        </FormItem>
        <FormItem label="媒体">
          <auto-complete :data="mediaData" v-model="modeMediaId" placeholder="全部" style="width: 280px" @on-select="handleMedia" />
        </FormItem>
        <FormItem label="对比素材">
          <Input
            :value="modeImageName"
            suffix="ios-search"
            style="width: 280px"
            @on-focus="pickMaterialShow"
            @on-click="pickMaterialShow"
          />
        </FormItem>
      </Form>
    </Modal>

    <!-- 选择对比素材列表 -->
    <pick-material v-model="pickModal" @on-select="pickMaterialSelect" />
  </div>
</template>
<script>
import moment from 'moment'
import { HOST_API } from '@/api/config'
import { isArray, timeout, isNumber } from '@/common/js/utils'
import { toPercentFixed } from '@/common/js/filters'
import AutoComplete from '@/components/autocomplete/autocomplete'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import PickMaterial from '@/components/material/material.vue'
import MCompareTable from './components/compare-table'
import { getSysMedia } from '@/api/common.model'
import { compareMaterialRecord } from '@/api/report.model'

const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')

// 框架数据结构
const dataShcme = [
  {
    id: 1,
    key: 'Basic',
    name: '基础数据',
    children: [
      'pv',
      'clickNum',
      'clickRate',
      'downNum',
      'createRoleNum',
      'createRoleCost',
      'payRoleUserRate',
      'newRoleMoney',
      'newRoleRate'
    ]
  },
  {
    id: 2,
    key: 'PlayData',
    name: '播放数据',
    children: [
      'totalPlay',
      'validPlay',
      'validPlayRate',
      'playOver',
      'playOverRate',
      'playDuration2sRate',
      'playDuration3sRate',
      'playDuration5sRate',
      'playDuration10sRate',
      'play25FeedBreakRate',
      'play50FeedBreakRate',
      'play75FeedBreakRate',
      'play100FeedBreakRate',
      'averagePlayTimePerPlay',
      'share',
      'comment',
      'like',
      'dislike',
      'follow',
      'messageAction',
      'report'
    ]
  },
  {
    id: 5, // 字段大于10考虑处理位数
    key: 'RetainRate',
    name: '创角留存',
    children: [
      'createRoleTwoDayRetainRate',
      'createRoleThreeDayRetainRate',
      'createRoleFourDayRetainRate',
      'createRoleFiveDayRetainRate',
      'createRoleSixDayRetainRate',
      'createRoleSevenDayRetainRate',
      'createRoleTenDayRetainRate',
      'createRoleFifteenDayRetainRate',
      'createRoleThirtyDayRetainRate'
    ]
  },
  {
    id: 6,
    key: 'DayLtv',
    name: '创角LTV',
    children: [
      'createRoleOneDayLtv',
      'createRoleTwoDayLtv',
      'createRoleThreeDayLtv',
      'createRoleFourDayLtv',
      'createRoleFiveDayLtv',
      'createRoleSixDayLtv',
      'createRoleSevenDayLtv',
      'createRoleTenDayLtv',
      'createRoleFifteenDayLtv',
      'createRoleThirtyDayLtv'
    ]
  }
]

export default {
  name: 'MaterCompare',
  components: { AutoComplete, DateRangePicker, PickMaterial, MCompareTable },
  data() {
    return {
      loading: null,
      showTable: null,
      pickModal: null,
      modal: null,
      tableList: [],
      compares: [],
      noData: null,
      asyning: null, // 添加对比素材状态
      modePlatform: 0,
      modeMediaId: '',
      modeImageName: null,
      datetime: [],
      mediaData: []
    }
  },
  methods: {
    getData() {
      const params = JSON.parse(JSON.stringify(this.compares))
      this.loading = true
      this.noData = false
      compareMaterialRecord(params).then((data) => {
        if (isArray(data)) {
          this.tableList = this.switchToData(data)
          this.loading = false
          this.showTable = true
        } else if (!data) {
          this.loading = false
          this.showTable = false
          this.noData = true
        }
      })
    },
    switchToData(data) {
      const compareObj = data[0]
      return dataShcme.map((ret) => {
        const pid = ret.id
        ret = Object.assign({}, compareObj, ret)
        ret.children = ret.children.map((met, i) => {
          const id = pid * 10 + i
          const obj = data.filter((r) => r.key === met).pop()
          // 百分比值格式化
          if (obj.key.indexOf('Rate') > -1) {
            ;[
              'refrence',
              'compared1',
              'compared2',
              'compared3',
              'compared4',
              'compared5',
              'comparedDif1',
              'comparedDif2',
              'comparedDif3',
              'comparedDif4',
              'comparedDif5'
            ].forEach((t) => {
              obj[t] = isNumber(obj[t]) ? toPercentFixed(obj[t]) : ''
            })
          }
          return Object.assign({}, { id }, obj)
        })
        return ret
      })
    },
    addCompares() {
      this.modal = true
    },
    delCompares(index) {
      this.showTable = false
      this.compares.splice(index, 1)
    },
    convertCompares(index) {
      this.showTable = false
      const [shift] = this.compares.splice(index, 1)
      this.compares.unshift(shift)
    },
    pickMaterialShow() {
      this.pickModal = true
    },
    handlePlatform(val) {
      this.modePlatform = val
    },
    handleMedia(meta) {
      this.modeMediaId = meta.id
    },
    handleDatetime(dates) {
      const [start, end] = dates
      const limitDate = moment(end).subtract(90, 'days')

      if (limitDate.isAfter(start)) {
        this.$Message.warning('日期范围不能超过90天！')
        const newDate = limitDate.format('YYYY-MM-DD')
        this.datetime = [newDate, end]
      }
    },

    pickMaterialSelect(val) {
      if (val && val.imageId && val.imageName) {
        this.currentMater = val
        this.modeImageName = val.imageName
      } else {
        this.$Message.warning('选择的对比素材信息有误！')
        return false
      }
    },
    // 添加素材选择回调
    asyncSelect() {
      if (!this.currentMater) {
        this.$Message.warning('对比素材不能为空！')
        this.asyning = true
        timeout(0).then(() => {
          this.asyning = false
        })
        return false
      }

      const { imageId, imageName } = this.currentMater
      if (this.compares.length < 6) {
        this.showTable = false
        this.currentMater = null
        this.compares.push({
          imageId,
          imageName,
          beginTime: this.datetime[0],
          endTime: this.datetime[1],
          platform: this.modePlatform,
          mediaId: this.modeMediaId || -1
        })
        timeout(600).then(() => {
          this.modal = false
        })
      }
    },
    bindGetData(val) {
      // 还原默认值
      if (val) {
        this.currentMater = null
        this.modeImageName = null
        this.modePlatform = 0
        this.modeMediaId = ''
        this.datetime = [yesterday, yesterday]
      }
    },
    downData() {
      const params = this.compares
        .map((ret) => `${ret.imageId}|${ret.imageName}|${ret.beginTime}|${ret.endTime}|${ret.platform}|${ret.mediaId}`)
        .join(',')
      let url = `${HOST_API}/api/ptom/media/downloadMaterialDataComparison`
      url += `?sessionid=${this.$store.state.token}`
      url += `&params=${params}`
      window.open(url)
    },
    proLoadData() {
      Promise.all([getSysMedia()]).then((data) => {
        if (!data) return
        const [medias] = data
        if (isArray(medias)) {
          this.mediaData = medias.map((ret) => {
            return {
              id: ret.mediaId,
              name: ret.mediaName
            }
          })
        }
      })
    }
  },
  watch: {
    compares: {
      handler(nVal) {
        this.getData()
      },
      deep: true
    }
  },
  created() {
    const beginTime = this.$route.query.beginTime
    const endTime = this.$route.query.endTime
    const platform = Number(this.$route.query.platform)
    const mediaId = Number(this.$route.query.mediaId)
    const ids = this.$route.query.ids
    const names = this.$route.query.names
    // 日期默认值
    this.datetime = [yesterday, yesterday]
    this.proLoadData()
    // 处理对比数组
    if (ids.indexOf(',') > -1 && names.indexOf(',') > -1) {
      const imageIds = ids.split(',')
      const imageNames = names.split(',')
      this.compares = imageIds.map((ret, i) => {
        return {
          imageId: ret,
          imageName: imageNames[i],
          beginTime,
          endTime,
          platform,
          mediaId
        }
      })
    } else {
      this.compares = [
        {
          imageId: ids,
          imageName: names,
          beginTime,
          endTime,
          platform,
          mediaId
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-material-compare {
  position: relative;

  .c-control-btn {
    padding: 0 10px;

    .c-btn-group {
      line-height: 30px;
      height: 32px;
      border-radius: 3px;
      width: 100px;
      display: inline-block;
      vertical-align: middle;
    }

    .c-show-switch {
      height: 32px;
      display: flex;
      align-items: center;
      padding: 0 10px 0 5px;

      span {
        padding: 0 8px;
      }
    }
  }

  .c-title {
    font-size: 16px;
    line-height: 38px;
    color: #666;
  }
}
</style>
